// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_iz-0";
export var fileCarousel = "_iz-2";
export var removeFileButton = "_iz-1";